import { Component, OnInit, Input } from '@angular/core';
import { Validators, FormControl, FormGroup } from '@angular/forms';
import { Helper } from '../../Helper';
import { Router } from '@angular/router';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { MatDialog, MatBottomSheet } from '@angular/material';
import {Location} from '@angular/common';

@Component({
  selector: 'app-compose-message',
  templateUrl: './compose-message.component.html',
  styleUrls: ['./compose-message.component.css','../../sub-admin/subadmin.component.css','../../../assets/bootstrap.css']
})
export class ComposeMessageComponent implements OnInit {
  form = new FormGroup({
      
     
    subject: new FormControl('', [Validators.required]),
    description: new FormControl('', [Validators.required]),
    
    
  }); 
  @Input() module="";
  @Input() afterSendAction;
  @Input() to="";
  @Input() subject="";
   
  editorConfig: AngularEditorConfig = {
    editable: true,
      spellcheck: true,
      height: 'auto',
      minHeight: '100px',
      maxHeight: 'auto',
      width: 'auto',
      minWidth: '0',
      translate: 'yes',
      enableToolbar: true,
      showToolbar: true,
      placeholder: 'Enter text here...',
    // toolbarHiddenButtons: [
      
    //   ['insertImage']
    // ]
};
  constructor(public Helper:Helper,public router:Router, public dialog:MatDialog,private _location: Location) { 
    this.editorConfig["uploadUrl"]=this.Helper.globalAPiUrl+"admin/upload-image?token="+this.Helper.get("token");
    
  }

  ngOnInit() {

     if(this.subject){
      this.form.controls["subject"].setValue(this.subject)
     } 
    if(this.to){
      this.Helper.makeRequest("admin/search-user",{keyword:this.to,notin:[]},"post",{toast:false}).subscribe(data=>{
        if(data.data && data.data[0])
          this.selected(data.data[0]);
      },err=>{
      })

    }
  }
  search=""
  timer=null
  users=[]
  selectedUsers=[]
  searchTrainer(e){
      
    if(this.search=="")  return 1;  
    
    if(this.timer)
      clearTimeout(this.timer);

    this.timer=setTimeout(()=>{
      let users=this.selectedUsers.map(i=>{
        return i.id
      })
      this.Helper.makeRequest("admin/search-user",{keyword:this.search,notin:users},"post",{toast:false}).subscribe(data=>{
        this.users=data.data;
      },err=>{
      })
    },500)
    
  }
  remove(i){
   
    this.selectedUsers.splice(i,1);
    
  }
 
  selected(e){
    
  this.selectedUsers.push( e);
  this.users=[]

  }
  loading=false;
  submit(){
  console.log(this.form.valid ,this.form)
     if(this.selectedUsers.length<=0){
     return  this.Helper.toast("Please select atleast one user email","error")
     }
    if(!this.form.valid ){
      return 1;
    }
    this.loading=true;
    let to_user_id=[];
    for(let user of this.selectedUsers){
      to_user_id.push(user.id);
    }
    this.form.value.to_user_id=JSON.stringify(to_user_id);
    this.Helper.makeRequest("admin/compose",this.form.value,"postupload").
    subscribe((data)=>{ 
      this.loading=false;
      if(this.afterSendAction)
      {
        this.afterSendAction.close();
      }
      else
      this.router.navigate(["/"+this.module+"/message/sent"]) ;     
      
       

    },(err)=>{
      this.loading=false;
      console.log(err.error);
      // this.form.value.dob=olddob
      this.Helper.showServerErrors(err.error.errors,this.form);
      this.Helper.toast(err.error.message,"error")
      this.loading=false;
      this.Helper.showLoader(false); 
       
    });
  }

  closeBtn(){
    console.log("close trigger");
    if(this.afterSendAction)
    this.dialog.closeAll();
    else
    this.router.navigate(["/"+this.module+"/message/inbox"]) ;   
    
  }

}
